<!-- logo-parrain.component.html -->
@if (isLoading()) {
<!-- État de chargement -->
<div [class]="containerTailwindClasses()">
  <div class="animate-pulse bg-gray-200 rounded-md w-full h-full"></div>
</div>
} @else if (hasError()) {
<!-- État d'erreur -->
<div [class]="containerTailwindClasses()">
  <div class="text-red-500 text-xs text-center">Erreur</div>
</div>
} @else if (shouldShowSwiper()) {
<!-- Affichage en swiper pour plusieurs sponsors principaux -->
<div [class]="containerTailwindClasses()" [attr.data-swiper-key]="swiperKey()">
  <swiper [config]="swiperConfig" class="w-full h-full flex items-center justify-center">
    @for (sponsor of mainSponsors(); track sponsor.id) {
      <ng-template swiperSlide>
        <div class="w-full h-full flex items-center justify-center" [class]="buildContainerClass(sponsor)">
          <img [class]="buildLogoClass(sponsor)" [ngSrc]="buildLogoUrl(sponsor)"
            [width]="imageWidth()" [height]="imageHeight()"
            [alt]="sponsor.name" (click)="parrainClicked.emit(sponsor.id)" loading="lazy" />
        </div>
      </ng-template>
    }
  </swiper>
</div>
} @else {
<!-- Affichage simple pour un seul sponsor -->
@if (logoSrc(); as src) {
<div class="flex items-center justify-center" [class]="containerClass()">
  <img [class]="logoClass()" [ngSrc]="src" [width]="imageWidth()" [height]="imageHeight()" alt="{{parrain()?.name}}"
    loading="lazy" (click)="parrainClicked.emit(parrain()?.id)" class="cursor-pointer" />
</div>
} @else {
<!-- Logo par défaut -->
<div [class]="containerTailwindClasses()">
  <img class="w-14 h-auto object-contain" ngSrc="assets/images/logo/kappsi-logo.png" [width]="imageWidth()"
    [height]="imageHeight()" alt="Logo par défaut" loading="lazy" />
</div>
}
}